/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBannersResponse } from '../../models/get-banners-response';

export interface GachaServiceGetBanners$Params {

/**
 * If set, only return banners that are visible.
 */
  onlyGetVisible?: boolean;

/**
 * If set, only return banners that are current. These CAN be not visible depending
 * on the value of only_get_visible.
 */
  onlyGetCurrent?: boolean;
}

export function gachaServiceGetBanners(http: HttpClient, rootUrl: string, params?: GachaServiceGetBanners$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBannersResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetBanners.PATH, 'get');
  if (params) {
    rb.query('onlyGetVisible', params.onlyGetVisible, {});
    rb.query('onlyGetCurrent', params.onlyGetCurrent, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBannersResponse>;
    })
  );
}

gachaServiceGetBanners.PATH = '/api/v3/gateway/banners/gacha';
